import { setHasShownToast } from '../offline/offlineToastState'

// Reset when connection comes back
window.addEventListener('online', () => {
  console.log('online')
  setHasShownToast(false)
})
